/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  FACEBOOK_FOR_DEVELOPERS_LINK: 'https://developers.facebook.com',
  FACEBOOK_FOR_DEVELOPERS_SUBMITTING_APP_LINK:
    'https://developers.facebook.com/docs/messenger-platform/app-review/',
  facebookLearnMoreNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-facebook'
  ),
  facebookLearnMoreClassicIA: generateDocsUrl(
    '/assistant?topic=assistant-deploy-facebook'
  ),
  learnMoreRequestURL: generateDocsUrl('/?topic=assistant-release-notes'),
  learnMoreRequestUrlNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-watson-assistant-release-notes'
  ),
  learnMoreGDPR: generateDocsUrl('/?topic=assistant-information-security'),
  learnMoreGDPRNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-admin-securing'
  )
};
